"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HelpDependencies = void 0;
var _dependenciesParseGenerated = require("./dependenciesParse.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var HelpDependencies = exports.HelpDependencies = {
  parseDependencies: _dependenciesParseGenerated.parseDependencies,
  createHelpClass: _factoriesAny.createHelpClass
};